/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
/**
 * Define the the sign in feature initial state
 */
export const initialState = {
  loading: false,
  error: '',
};
/**
 * Here mentioned all the sign in feature related actions
 */
export const signInSlice = createSlice({
  name: 'feature/sign-in',
  initialState,
  reducers: {
    signIn(state) {
      state.loading = true;
      state.error = '';
    },
    signInSucceeded(state) {
      state.loading = false;
      state.error = '';
    },
    signInFailed(state, action) {
      state.loading = false;
      state.error = action?.payload?.message;
    },
  },
});
//
export const { actions: signInActions } = signInSlice;
